import { useEffect, useState } from "react";
// * constants
import { apiUrls } from "../utils/urls";

const CustomImage = ({
  objectKey,
  token,
}: {
  objectKey: string;
  token: string | null;
}) => {
  const [imageData, setImageData] = useState<string | null>(null);

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const response = await fetch(
          `${apiUrls.baseURL}/${apiUrls.media.replace(/%s/, objectKey)}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.ok) {
          const blob = await response.blob();
          setImageData(URL.createObjectURL(blob));
        }
      } catch (error) {
        console.log("Error fetching image:", error);
      }
    };

    fetchImage();
  }, [objectKey, token]);

  return imageData ? (
    <img
      src={imageData}
      alt={`custom-${imageData}`}
      className="object-cover w-full h-full"
    />
  ) : (
    <div>Loading image</div>
  );
};

export default CustomImage;
